import { render, staticRenderFns } from "./index.vue?vue&type=template&id=10e66d3e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=10e66d3e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e66d3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10e66d3e')) {
      api.createRecord('10e66d3e', component.options)
    } else {
      api.reload('10e66d3e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=10e66d3e&scoped=true", function () {
      api.rerender('10e66d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/order/csg-admin/index.vue"
export default component.exports